module.exports = __webpack_public_path__ + "static/media/stock.cfa859e7.png";